module.exports = __webpack_public_path__ + "static/p3-0b7e1550be42638f97745ac2aef9d79f.jpg";